// @flow
import React, { type Node } from 'react';
import PropTypes from 'prop-types';
import { WizardComponent } from 'angieslist-app-platform/lib/browser/wizard';
import { compose, pure } from 'recompose';
import { connect } from 'react-redux';
import { Grid, Row } from 'angieslist-react-components';
import Helmet from 'react-helmet-async';
import queryString from 'query-string';
import classNames from 'classnames';
import { get } from 'lodash';
import './welcome.scss';
import BusinessDescriptionForm from './components/BusinessDescriptionForm';
import ServiceCategoriesForm from './components/ServiceCategoriesForm';
import ServiceAreaMap from '../../../app/browser/service-areas/ServiceAreaMap';
import type { LatLong, ServiceProviderCacheState } from '../../../app/types';

const headers = [
  (<div key="pageHeader"><h1 className="h4">Your Business Description</h1></div>),
  (<div key="pageHeader"><h1 className="h4">Your Service Categories</h1></div>),
  (<div key="pageHeader"><h1 className="h4">Your Service Area</h1></div>),
];

/* eslint react/prefer-stateless-function: 0 */
export class WelcomeViewComponent extends React.Component<*> {
  props: {
    serviceProviderCache: ServiceProviderCacheState,
    location: any,
    params: {
      serviceProviderId: number,
    }
  }

  render(): Node {
    const {
      serviceProviderCache, params: { serviceProviderId }, location,
    } = this.props;
    const serviceProviderLocation = get(serviceProviderCache, `${serviceProviderId}.primaryAddress.location`, ({
      // default to Indianapolis
      lon: -86.1581,
      lat: 39.7684,
    }: LatLong));
    const step = get(queryString.parse(location.search), 'step', '1');
    return (
      <Grid>
        <Helmet>
          <title>Welcome</title>
        </Helmet>
        <Row className={classNames({ 'service-area-step': step === '3' })} >
          <WizardComponent
            router={this.context.router}
            id="welcome--wizard"
            bsStyle="primary-office"
            headers={headers}
            submitButtonContent={(<span className="wizard-button">Done</span>)}
            onFinalSubmit={() => {
              this.context.router.push({ pathname: `/app/welcome/${serviceProviderId}/download-app` });
            }}
          >
            <BusinessDescriptionForm serviceProviderId={serviceProviderId} key="BusinessDescription" />
            <ServiceCategoriesForm serviceProviderId={serviceProviderId} key="ServiceCategories" />
            <ServiceAreaMap
              serviceProviderId={serviceProviderId}
              advertisingArea={[]}
              serviceArea={[]}
              serviceProviderLocation={serviceProviderLocation}
              showEditControls={false}
              key="ServiceAreas"
            />
          </WizardComponent>
        </Row>
      </Grid>
    );
  }
}

WelcomeViewComponent.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default (compose(
  connect(state => ({
    serviceProviderCache: state.serviceProviderCache,
  })),
  pure,
)(WelcomeViewComponent): any);



// WEBPACK FOOTER //
// ./src/modules/home/browser/WelcomeView.js